import { render, staticRenderFns } from "./SearchButton.vue?vue&type=template&id=2f8b12b5&"
import script from "./SearchButton.vue?vue&type=script&lang=js&"
export * from "./SearchButton.vue?vue&type=script&lang=js&"
import style0 from "./SearchButton.vue?vue&type=style&index=0&id=2f8b12b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports